import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

const OptionRow = ({
    formattedPrice,
    id,
    type,
    desc,
    classes,
}) => (
    <TableRow>
        <TableCell id={`${id}Type`}>
            <FormattedMessage {...type} />
        </TableCell>
        <TableCell id={`${id}Desc`} className={classes.optionsDescColumn}>
            { desc }
        </TableCell>
        <TableCell id={`${id}Price`} className={classes.optionsPriceColumn}>
            {formattedPrice}
        </TableCell>
    </TableRow>
);

OptionRow.propTypes = {
    formattedPrice: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    type: PropTypes.object.isRequired,
    desc: PropTypes.string,
    classes: PropTypes.object.isRequired,
};

export default OptionRow;
